interface IGetCustomerBlackListRequest {
    customerId: string;
}
class GetCustomerBlackListRequest implements IGetCustomerBlackListRequest{
    public customerId: string;
}

interface IAddCustomerBlackListRequest {
    customerId: string;
    domain: string;
    domains: string[];
}
class AddCustomerBlackListRequest implements IAddCustomerBlackListRequest{
    public customerId: string;
    public domain: string;
    public domains: string[];
}

interface IDeleteCustomerBlackListRequest {
    customerId: string;
    index: number;
    domains: string[];
}
class DeleteCustomerBlackListRequest implements IDeleteCustomerBlackListRequest{
    public customerId: string;
    public index: number;
    public domains: string[];
}

export {
    GetCustomerBlackListRequest,
    AddCustomerBlackListRequest,
    DeleteCustomerBlackListRequest,
}


// WEBPACK FOOTER //
// ./src/presentation/request/customer_black_request.ts